import { render, staticRenderFns } from "./CompanyDropdown.vue?vue&type=template&id=1f22c46e&"
import script from "./CompanyDropdown.vue?vue&type=script&lang=ts&"
export * from "./CompanyDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QPopupProxy,QList,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QBtn,QPopupProxy,QList,QItem,QItemSection,QItemLabel}, component.options.components || {})
